/* globals google, jsts */

import Venue from '../framework/models/venue';

import Marker from '../framework/views/marker';
import MarkerSet from '../framework/collection-views/marker-set';

import getCssMarker from '../utilities/cssMarker';

import mapStyles from '../data/mapstyles';

export default function( $, app ) {
	const CssMarker = getCssMarker();

	const geoReader = new jsts.io.GeoJSONReader();
	const geoWriter = new jsts.io.GeoJSONWriter();

	const kmDegrees = 112; // to be ironed out

	var {
		model: session,
		foundVenues,
		views: {
			venueDetails,
			venuesList: { collection: venues },
			myItinerary: { collection: myVenues },
		},
		router,
	} = app;

	const mapOptions = {
		zoom: 12,
		disableDefaultUI: true,
		gestureHandling: 'greedy',
		clickableIcons: false,
		styles: mapStyles,
		zoomControl: true,
		zoomControlOptions: {
			position: google.maps.ControlPosition.RIGHT_BOTTOM,
		},
	};

	// =========================
	// ! Venue Map Setup
	// =========================

	var eventMap = new google.maps.Map( document.getElementById( 'venue-details-map' ), mapOptions );

	var eventMarker = new Marker( {
		map: eventMap,
		objClass: CssMarker,
		className: 'map-marker marker-location',
		model: new Venue(),
	} );

	venueDetails.on( 'rebind', function() {
		var location = this.model;
		eventMarker.rebind( location );
		eventMap.setCenter( location.getPosition() );
		eventMap.setZoom( 15 );
	} );

	// =========================
	// ! Trip Map Setup
	// =========================

	var tripMap = new google.maps.Map( document.getElementById( 'venues-map' ), mapOptions );

	// =========================
	// ! Trip Map Markers
	// =========================

	var originMarker = new Marker( {
		map: tripMap,
		objClass: CssMarker,
		model: session.origin,
		className: 'map-marker marker-origin',
	} );

	originMarker.render();

	var destinationMarker = new Marker( {
		map: tripMap,
		objClass: CssMarker,
		model: session.destination,
		className: 'map-marker marker-destination',
	} );

	destinationMarker.render();

	var stopMarkers = new MarkerSet( {
		el: tripMap,
		collection: venues,
		childOptions: {
			objClass: CssMarker,
			className: 'map-marker marker-waypoint',
		},
	} );

	stopMarkers.render();

	// =========================
	// ! Trip Map Overlays
	// =========================

	var tripAreaShape = new google.maps.Circle( {
		clickable: false,
		radius: 1000,
		fillColor: '#ca6f58',
		fillOpacity: 0.1,
		strokeWeight: 2,
		strokeColor: '#ca6f58',
		strokeOpacity: 0.3,
	} );

	var tripRoadPath = new google.maps.Polyline( {
		clickable: false,
		geodesic: true,
		strokeColor: '#0c1a42',
		strokeOpacity: 0.5,
		strokeWeight: 5,
	} );

	var tripRoadShape = new google.maps.Polygon( {
		clickable: false,
		fillColor: '#ca6f58',
		fillOpacity: 0.1,
		strokeWeight: 2,
		strokeColor: '#ca6f58',
		strokeOpacity: 0.3,
	} );

	// =========================
	// ! Trip Map Updating
	// =========================

	function placeObjects() {
		if ( session.get( 'type' ) === 'road' ) {
			originMarker.show();
			destinationMarker.show();

			tripRoadShape.setMap( tripMap );
			tripAreaShape.setMap( null );
		} else {
			originMarker.show();
			destinationMarker.hide();

			tripAreaShape.setMap( tripMap );
			tripRoadShape.setMap( null );
		}
	}

	session.on( 'change:type', placeObjects );
	placeObjects();

	function fitTripMap() {
		// Abort if not a road trip or no origin/destination set yet
		if ( session.get( 'type' ) !== 'road' || ! session.get( 'origin' ) || ! session.get( 'destination' ) ) {
			return;
		}

		var bounds = new google.maps.LatLngBounds( session.origin.getPosition() );
			bounds.extend( session.destination.getPosition() );

		tripMap.fitBounds( bounds, 50 );
	}

	session.onChanged( 'origin_position destination_position', fitTripMap );
	tripMap.addListener( 'resize', fitTripMap );
	fitTripMap();

	function centerAreaMap() {
		// Abort if not an area trip or no origin set yet
		if ( session.get( 'type' ) !== 'area' || ! session.get( 'origin' ) ) {
			return;
		}

		var center = new google.maps.LatLng( session.origin.getPosition() );
		var area = parseInt( session.get( 'area' ), 10 );

		tripMap.setCenter( center );

		tripAreaShape.setCenter( center );
		tripAreaShape.setRadius( area * 1000 );

		tripMap.fitBounds( tripAreaShape.getBounds() );

		foundVenues.addPredicate( 'withinArea', model => {
			var coords = new google.maps.LatLng( model.getPosition() );
			return google.maps.geometry.spherical.computeDistanceBetween( coords, center ) <= area * 1000;
		}, () => {
			// Only bother if it's an area trip and less than the max
			return session.get( 'type' ) === 'area' && area < 50;
		} );
	}

	session.on( 'change:origin_position change:area', centerAreaMap );
	tripMap.addListener( 'resize', centerAreaMap );
	centerAreaMap();

	// =========================
	// ! Trip Route Handling
	// =========================

	function drawRoute() {
		// Abort if not a road trip or no origin/destination set yet
		if ( session.get( 'type' ) !== 'road' || ! session.get( 'route' ) ) {
			return;
		}

		var route = session.get( 'route' );
		var area = parseInt( session.get( 'area' ), 10 );

		var path = route.coordinates.map( ( [ lng, lat ] ) => ( { lat, lng } ) );

		if ( path.length < 2 ) {
			tripRoadPath.setPath( [] );
			tripRoadShape.setPath( [] );
			return;
		}

		tripRoadPath.setPath( path );

		var polygon = geoWriter.write( geoReader.read( route ).buffer( area / kmDegrees ) );

		var paths = polygon.coordinates.map( coords => coords.map( ( [ lng, lat ] ) => ( { lat, lng } ) ) );

		tripRoadShape.setPaths( paths );

		foundVenues.addPredicate( 'withinArea', model => {
			var coords = new google.maps.LatLng( model.getPosition() );
			return google.maps.geometry.poly.containsLocation( coords, tripRoadShape );
		}, () => {
			// Only bother if it's a road trip and the path isn't empty
			return session.get( 'type' ) === 'road' && tripRoadPath.getPath().length > 0;
		} );
	}

	session.on( 'change:route change:area', drawRoute );
	drawRoute();

	// =========================
	// ! Stop Distance Handling
	// =========================

	function updateDistances() {
		if ( foundVenues.length === 0 ) {
			return;
		}

		var origin = new google.maps.LatLng( session.origin.getPosition() );

		foundVenues.each( event => {
			// Skip if origin hasn't changed and a distance is already set
			if ( ! session.changed.origin_position && event.get( 'distance' ) ) {
				return;
			}

			var point = new google.maps.LatLng( event.getPosition() );

			event.set( 'distance', google.maps.geometry.spherical.computeDistanceBetween( origin, point ) );
		} );

		foundVenues.sort();
	}

	session.on( 'change:origin_position', updateDistances );
	foundVenues.on( 'reset update', updateDistances );
	updateDistances();

	// =========================
	// ! Stop Marker Toggling
	// =========================

	myVenues
	.on( 'add', model => {
		var marker = stopMarkers.get( model.id );
		if ( marker ) {
			marker.el.addClass( 'selected' );
		}
	} )
	.on( 'remove', model => {
		var marker = stopMarkers.get( model.id );
		if ( marker ) {
			marker.el.removeClass( 'selected' );
		}
	} );

	stopMarkers.on( 'child:select', child => {
		router.navigate( 'venue/' + child.model.id, { trigger: true } );
	} );

	// =========================
	// ! Map View Handling
	// =========================

	$( '#map_view' ).change( function() {
		$( '#venues' ).toggleClass( 'show-alternate', this.checked );
	} ).trigger( 'change' );

	// =========================
	// ! Expose to app object
	// =========================

	app.eventMap = eventMap;
	app.tripMap = tripMap;
	app.markers = { originMarker, destinationMarker, stopMarkers };
	app.overlays = { tripAreaShape, tripRoadShape, tripRoadPath };
}
